import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IContactInfo } from "utils/offer";

export type IExternalUrl = {
  externalUrl: string;
};

type TInput = { offerId: number };
type TOutput = IContactInfo | IExternalUrl;

export default class GetContactInfoApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri({ offerId }: TInput): string {
    return `/fe-api/offer/contact-info/${offerId}`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    if (data.external_url) {
      return {
        externalUrl: data.external_url,
      };
    } else {
      return {
        isPrivateLandlord: data.is_private_landlord,
        firstName: data.first_name,
        lastName: data.last_name,
        phone: data.phone,
        hasPhone: data.hasPhone,
        companyName: data.company_name,
        photoUrl: data.photo_url,
        displayNameFields: data.display_name_fields,
        defaultMessage: data.default_msg,
        isOfferWithCreditCheck: data.is_offer_with_credit_check,
        premiumAccountCountdown: data.premium_acc_countdown,
        noEmail: data.no_email ? data.no_email : false,
        isIn: data.is_in,
      };
    }
  }
}
